import { useTranslation } from 'react-i18next'
import Icon from './ui/Icon'

/**
 * Shown next to a member's name once their phone number is confirmed.
 *
 * Icon only — no label. Absence is the unverified state, the convention people
 * already know from other apps, so nothing is drawn for unverified users. The
 * profile page carries a separate banner telling them what to do about it,
 * which matters more than it used to: unverified numbers are no longer offered
 * as wake-up targets, so without it they would silently never be called.
 *
 * Because there is no visible text, the meaning is carried by title (hover) and
 * aria-label (screen readers) rather than left to the icon alone.
 *
 * `onDark` is for the gradient profile header; elsewhere the green reads better.
 */
const VerifiedBadge = ({ onDark = false, className = '' }) => {
  const { t } = useTranslation()
  const label = t('profile.verifiedTooltip')

  return (
    <Icon
      name="CheckCircle"
      role="img"
      title={label}
      aria-label={label}
      className={`w-5 h-5 shrink-0 align-middle ${onDark ? 'text-white' : 'text-primary'} ${className}`}
    />
  )
}

export default VerifiedBadge
